<template>
    <v-container class="no-available text-center">
        <v-row class="text-center" no-gutters>
            <v-col>
                <div v-if="position === 'top'" v-html="message">
                </div>

                <div>
                    <h1 class="logoutv2">
                    O 
                <!-- // Logout -->        
                    <a color="primary"   
                            @click="logout()"
                        >
                            <span>cierre sesión</span>
                    </a> para ingresar con otro usuario
                </h1>
                
                </div>
                
                <img
                    class="img-fluid"
                    src="@/assets/images/no-available.png"
                    alt="No Available"
                />
                <div v-if="position === 'bottom'" v-html="message"></div>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { mapActions } from "vuex";

export default {
    props: ["message", "position"],
    name: "RomaNoAvailable",
    methods: {
        ...mapActions({
            resetEvaluation: "resetEvaluation",
            resetUser: "resetUser",
            resetPdf: "resetPdf",
            resetTimer: "resetTimer",
            setTimeEndRemainingZero: "setTimeEndRemainingZero"
        }),
        logout() {
            this.resetUser();
            this.resetEvaluation();
            this.resetPdf();
            this.resetTimer();
            this.setTimeEndRemainingZero(false);
            window.location = process.env.VUE_APP_ROMA_LOGOUT_CAS;
        }
    }
};
</script>
<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Cabin:wght@400;500;600;700&display=swap");
.no-available {
    text-align: center;
    width: 100%;
    h1,
    h2,
    h3 {
        font-family: "Cabin", Regular, sans-serif !important;
        text-align: center;
        letter-spacing: 0;
        color: #484848;
        opacity: 1;
        font-weight: 300;
    }
    h1 {
        font-size: 26px;
    }
    img {
        margin-top: 10px;
        width: 40%;
    }
}
.logoutv2{
   font-size: 26px !important;
}

@media (max-width: 800px) {
    .no-available {
        text-align: center;
        margin: 0 auto;
        h1 {
            font-size: 18px;
            font-weight: 300;
        }
        img {
            margin-top: 1px;
            width: 50%;
        }
    }
}
</style>
